export const KeywordNames = {
  Charge: 'Charge',
  Drain: 'Drain',
  Ward: 'Ward',
  Prophecy: 'Prophecy',
  Guard: 'Guard',
  Rally: 'Rally',
  Regenerate: 'Regenerate',
  Breakthrough: 'Breakthrough',
  Lethal: 'Lethal',
  Mobilize: 'Mobilize'
}

export const AttributeNames = {
  Strength: 'Strength',
  Willpower: 'Willpower',
  Intelligence: 'Intelligence',
  Agility: 'Agility',
  Endurance: 'Endurance',
  Neutral: 'Neutral'
}

export const DualColorClasses = {
  Battlemage: 'Battlemage',
  Crusader: 'Crusader',
  Archer: 'Archer',
  Warrior: 'Warrior',
  Mage: 'Mage',
  Assassin: 'Assassin',
  Sorcerer: 'Sorcerer',
  Monk: 'Monk',
  Spellsword: 'Spellsword',
  Scout: 'Scout'
}

export const TriColorHouses = {
  Guildsworn: 'Guildsworn',
  Dagoth: 'Dagoth',
  Daggerfall: 'Daggerfall',
  Hlaalu: 'Hlaalu',
  Redoran: 'Redoran',
  Ebonheart: 'Ebonheart',
  Dominion: 'Dominion',
  Tribunal: 'Tribunal',
  Telvanni: 'Telvanni',
  Empire: 'Empire'
}

export const ExpansionSets = {
  CoreSet: 'Core Set',
  ForgottenHeroCollection: 'Forgotten Hero Collection',
  FallOfTheDarkBrotherhood: 'The Fall of the Dark Brotherhood',
  ReturnToClockworkCity: 'Return to Clockwork City',
  HeroesOfSkyrim: 'Heroes of Skyrim',
  MadhouseCollection: 'Madhouse Collection',
  HousesOfMorrowind: 'Houses of Morrowind',
  FrostSparkCollection: 'FrostSpark Collection',
  IsleOfMadness: 'Isle of Madness',
  AllianceWar: 'Alliance War',
  MoonsOfElsweyr: 'Moons of Elsweyr',
  JawsOfOblivion: 'Jaws of Oblivion',
  TamrielCollection: 'Tamriel Collection',
  MonthlyReward: 'Monthly Reward'
}

export const Rarities = {
  Common: 'Common',
  Rare: 'Rare',
  Epic: 'Epic',
  Legendary: 'Legendary',
  LegendaryUnique: 'Legendary - Unique'
}

export const MetaRaces = {
  Mer: [
    'Dark Elf',
    'High Elf',
    'Wood Elf',
    'Orc',
    'Dwemer',
    'Falmer',
    'Ayleid'
  ],
  'Playable Race': [
    'Dark Elf',
    'High Elf',
    'Wood Elf',
    'Orc',
    'Redguard',
    'Breton',
    'Imperial',
    'Nord',
    'Khajiit',
    'Argonian'
  ],
  Animal: [
    'Beast',
    'Fish',
    'Mammoth',
    'Mudcrab',
    'Reptile',
    'Skeever',
    'Spider',
    'Wolf'
  ],
  Undead: ['Mummy', 'Skeleton', 'Spirit', 'Vampire']
}

export const Races = {
  Argonian: 'Argonian',
  Ayleid: 'Ayleid',
  Automaton: 'Automaton',
  Beast: 'Beast',
  Breton: 'Breton',
  Centaur: 'Centaur',
  Chaurus: 'Chaurus',
  Creature: 'Ash Creature',
  Daedra: 'Daedra',
  Defense: 'Defense',
  Dragon: 'Dragon',
  Dreugh: 'Dreugh',
  Dwemer: 'Dwemer',
  'Dark Elf': 'Dark Elf',
  'High Elf': 'High Elf',
  'Wood Elf': 'Wood Elf',
  Elytra: 'Elytra',
  Fabricant: 'Fabricant',
  Factotum: 'Factotum',
  Falmer: 'Falmer',
  Fish: 'Fish',
  Giant: 'Giant',
  Goblin: 'Goblin',
  God: 'God',
  Grummite: 'Grummite',
  Harpy: 'Harpy',
  Imp: 'Imp',
  Imperial: 'Imperial',
  Khajiit: 'Khajiit',
  Kwama: 'Kwama',
  Lurcher: 'Lurcher',
  Mammoth: 'Mammoth',
  Mantikora: 'Mantikora',
  Minotaur: 'Minotaur',
  Mudcrab: 'Mudcrab',
  Mummy: 'Mummy',
  Nereid: 'Nereid',
  Netch: 'Netch',
  Nord: 'Nord',
  Ogre: 'Ogre',
  Orc: 'Orc',
  Reachman: 'Reachman',
  Redguard: 'Redguard',
  Reptile: 'Reptile',
  Skeever: 'Skeever',
  Skeleton: 'Skeleton',
  Spider: 'Spider',
  Spirit: 'Spirit',
  Spriggan: 'Spriggan',
  Troll: 'Troll',
  Vampire: 'Vampire',
  Wamasu: 'Wamasu',
  Werewolf: 'Werewolf',
  Wolf: 'Wolf',
  Wraith: 'Wraith'
}

export const CardTypes = {
  Action: 'Action',
  Item: 'Item',
  Support: 'Support',
  Creature: 'Creature'
}
